import React from 'react';
import { useTranslation } from 'react-i18next';
import { useErrorHandler } from '../../hooks/use-error-handler';
import { useStorage } from '../../hooks/use-storage';
import { useSwal } from '../../hooks/use-swal';
import { useAnalytics } from '../../utils/setup/analytics-setup';
import { AddressCard } from '../../components/location/address-card';
import { useAccountAddressesAPI } from '../../apis/account-address-api';

function useAddressDeleteModal() {
  const storage = useStorage();
  const { config } = storage;
  const { swal } = useSwal({ storage });
  const { analyticsPageView } = useAnalytics();
  const { deleteAccountAddressFromRemote } = useAccountAddressesAPI();
  const { handleErrorOnModal } = useErrorHandler();
  const { t } = useTranslation();

  function didOpen() {
    analyticsPageView('Delete Address');
  }

  async function show({ address, prepareOnPreConfirm }) {
    const result = await swal.fire({
      title: t('address-delete-modal.title'),
      html: (
        <AddressCard
          address={address}
          config={config}
          noStreetNumber={address.is_no_number}
          complement={address.complement}
        />
      ),
      icon: 'warning',
      didOpen,
      showConfirmButton: true,
      showLoaderOnConfirm: true,
      showCancelButton: true,
      confirmButtonText: t('delete'),
      cancelButtonText: t('cancel'),
      preConfirm: () => preConfirm({ address, prepareOnPreConfirm }),
    });

    return result;
  }

  async function preConfirm({ address, prepareOnPreConfirm }) {
    try {
      await deleteAccountAddressFromRemote(address.id);
      await prepareOnPreConfirm?.call(this);
    } catch (error) {
      handleErrorOnModal(error);
      return false;
    }

    return true;
  }

  return {
    showAddressdDeleteModal: show,
  };
}

export { useAddressDeleteModal };
